/** Shared MatPass illustration palette — keep both service cards visually aligned. */
export const ILLUSTRATION = {
  green: "#16A34A",
  greenDark: "#15803D",
  greenDeep: "#14532D",
  greenSoft: "#DCFCE7",
  greenMid: "#4ADE80",
  anthracite: "#18181B",
  anthraciteSoft: "#27272A",
  muted: "#52525B",
  line: "#E4E4E7",
  paper: "#F8FAF9",
  white: "#FFFFFF",
  sky: "#EEF2F0",
  asphalt: "#3F3F46",
  glass: "#CBD5E1",
};

export function IllustrationFrame({ children, className = "" }) {
  return (
    <div
      className={`absolute inset-0 overflow-hidden transition-transform duration-700 ease-out group-hover:scale-[1.04] ${className}`}
      aria-hidden
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 28% 18%, rgba(22,163,74,0.22), transparent 52%), radial-gradient(ellipse at 85% 30%, rgba(74,222,128,0.08), transparent 40%), linear-gradient(168deg, #2A2A2E 0%, #18181B 48%, #0B0B0D 100%)",
        }}
      />
      {/* Larger immersive art area — less padding so the scene fills the card */}
      <div className="absolute inset-0 flex items-center justify-center px-3 pt-2 pb-24 sm:px-5 sm:pb-28 lg:px-6 lg:pb-32">
        {children}
      </div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-matpro-anthracite via-matpro-anthracite/55 to-transparent" />
    </div>
  );
}
